<script setup>
import { ref } from "vue";
import {defineEmits, defineProps} from "vue";

const props = defineProps({
  modelValue: {
    type: String,
    default: ""
  },
  items: {
    type: Array,
    default: () => []
  },
  placeholder: {
    type: String,
    default: ""
  },
  withFileUpload: {
    type: Boolean,
    default: true
  },
  flat: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([
  "update:model-value",
  "add-item",
  "action-click",
  "file-selected"
]);

// Ссылка на скрытый input
const fileInput = ref(null);

// Обработчик клика по кнопке
const handleActionClick = () => {
  emit("action-click");
  // Если компонент поддерживает загрузку файлов, открываем диалог выбора файла
  if (props.withFileUpload) {
    fileInput.value?.click();
  }
};

// Обработчик выбора файла через input
const handleFileInputChange = (e) => {
  emit("file-selected", e);
};
</script>

<template>
  <div
    class="map-upload-panel"
    :class="{ 'map-upload-panel--flat': flat }"
  >
    <AvalComboBoxPrimary
      :model-value="modelValue"
      :items="items"
      size="large"
      label-key="name"
      :placeholder="placeholder"
      @update:model-value="val => $emit('update:model-value', val)"
      @add-item="val => $emit('add-item', val)"
    />

    <!-- Слот для кнопки действия -->
    <slot
      name="action-button"
      :on-click="handleActionClick"
    >
      <!-- Дефолтная кнопка, если слот не заполнен -->
      <AvalButtonAccentSecondary @click="handleActionClick">
        <slot name="button-content" />
      </AvalButtonAccentSecondary>
    </slot>

    <!-- Скрытый input для выбора файла -->
    <input
      v-if="withFileUpload"
      ref="fileInput"
      type="file"
      accept=".geojson,.json"
      style="display: none;"
      @change="handleFileInputChange"
    >
  </div>
</template>

<style scoped lang="scss">
.map-upload-panel {
  display: flex;
  background-color: var(--background-bg-white);
  box-shadow: 0 2px 5px 0 #7B87A536;
  padding: 10px;
  border-radius: 8px;
  gap: 5px;

  &--flat {
    padding: 0;
    box-shadow: none;
  }

  :deep(.combobox-wrapper) {
    background-color: var(--background-01);
  }

  :deep(.combobox-container) {
    flex: 1;
  }
}
</style>
